<template>
  <div>
    <div class="common-card-top">
      <div class="card_t_l">
        <div class="title">Current round details</div>
        <div class="total">You have stake/Total : <big-number :number="myBidNum" /> / <big-number :number="total" /></div>
      </div>
      <div class="card_t_r">
        <TopTime @finish="getData"></TopTime>
      </div>
    </div>
    <div class="common-card-main">
      <el-table class="common-table" :data="tableList" v-loading="loading"  height="6rem">
        <el-table-column prop="roundTime" label="Round Block">
        </el-table-column>
        <el-table-column label="Account">
          <template slot-scope="{ row }">
            <Account :value="row.bider"></Account>
          </template>
        </el-table-column>
        <el-table-column label="The last stake time" align="right">
          <template slot-scope="{ row }">
            {{ moment(row.time * 1000).format("YYYY.MM.DD HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column label="Cumulative Staked " align="right">
          <template slot-scope="{ row }">
            <big-number :number="row.amount" />
            <span class="td-word-sm">REP</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import TopTime from "./topTime.vue"
export default {
  components: {
    TopTime
  },
  data() {
    return {
      tableList: [],
      loading: false,
      myBidNum: undefined,
      total: undefined,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      try {
        this.loading = true
        this.contractBid =
          this.$store.getters.contractMap['contractBid'].contract
        this.contractBidAddress =
          this.$store.getters.contractMap['contractBid'].address
        if (this.getToken()) {
          this.getData()
        }
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    async getData() {
      this.getMyInfo()
      let res = await this.contractBid.methods["bidderList"]().call({
        from: this.$store.getters.metaMaskObj.account,
      });
      if(this.tableList.length > 0){
        if(this.tableList[0].round === res[2] ){
          this.tableList = []
        }
      }
      let s = this.moment(res[2] * 1000).format("mm:ss"),
        e = this.moment(res[2] * 1000 + (1000 * 60 * 5)).format("mm:ss")
      res[0].forEach(item => {
        this.tableList.push({
          bider: item[0],
          time: item[2],
          amount: item[1],
          roundTime: `${s}~${e}`,
          round:res[2]
        })
      });
      this.total = res[1]
    },
    async getMyInfo() {
      let res = await this.contractBid.methods["mybidAmount"]().call({
        from: this.$store.getters.metaMaskObj.account,
      });
      this.myBidNum = res
    },




  }

}
</script>

<style lang="scss" scoped>
.common-card-top {
  padding: 0.4rem;
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 0.32rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 0.4rem;

  }

  .total {
    margin-top: 0.2rem;
    font-size: 0.18rem;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #929DAD;
  }
}
</style>
